import SelectableImageGallery from "./SelectableImageGallery";

export default SelectableImageGallery;
